export type TranslationTarget = 'en' | 'es' | 'fr' | 'de' | 'ar';

const DICTIONARIES: Record<TranslationTarget, Record<string, string>> = {
  en: {},
  es: {
    hello: 'hola', home: 'inicio', search: 'buscar', settings: 'configuración', history: 'historial', bookmarks: 'marcadores', retry: 'reintentar', offline: 'sin conexión', password: 'contraseña', page: 'página', browser: 'navegador'
  },
  fr: {
    hello: 'bonjour', home: 'accueil', search: 'rechercher', settings: 'paramètres', history: 'historique', bookmarks: 'favoris', retry: 'réessayer', offline: 'hors ligne', password: 'mot de passe', page: 'page', browser: 'navigateur'
  },
  de: {
    hello: 'hallo', home: 'startseite', search: 'suchen', settings: 'einstellungen', history: 'verlauf', bookmarks: 'lesezeichen', retry: 'erneut versuchen', offline: 'offline', password: 'passwort', page: 'seite', browser: 'browser'
  },
  ar: {
    hello: 'مرحبًا', home: 'الرئيسية', search: 'بحث', settings: 'الإعدادات', history: 'السجل', bookmarks: 'الإشارات', retry: 'إعادة المحاولة', offline: 'غير متصل', password: 'كلمة المرور', page: 'صفحة', browser: 'متصفح'
  }
};

export function dictionaryFor(target: string): Record<string, string> {
  return DICTIONARIES[(target as TranslationTarget) || 'en'] || {};
}

export function translatePlainText(text: string, target: string): string {
  const dictionary = dictionaryFor(target);
  return Object.entries(dictionary).reduce((acc, [source, replacement]) => {
    return acc.replace(new RegExp(`\\b${source.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'gi'), replacement);
  }, text);
}
